export default "__VITE_ASSET__3OfniJv5__"